import React from 'react'
import { FormDisplayErrors } from '@myxplor/forms'
export const defaultValues = {
  PreviousHistory: {
    individualSubjectTo: undefined,
    entitySubjectTo: undefined,
  },
}

export const PreviousHistory = ({ onChange, errorAtKey, errors = {} }) => (
  <fieldset>
    <legend>Previous History</legend>

      <div>
        In the last five (5) years has the individual:
        <ol className="numbers">
          <li>been subject to administration, receivership, liquidation, bankruptcy?</li>
          <li>
            incurred any debts to the Commonwealth (whether or not the debt has been discharged)
          </li>
        </ol>
        <FormDisplayErrors
          errors={errorAtKey({ key: 'PreviousHistory.individualSubjectTo', errors })}
        />
        <div className="radioButtonGroup">
          <label>
            <input
              type="radio"
              name="PreviousHistory.individualSubjectTo"
              value={true}
              onChange={() => onChange('PreviousHistory.individualSubjectTo', true)}
            />
            Yes
          </label>
          <label>
            <input
              type="radio"
              name="PreviousHistory.individualSubjectTo"
              value={false}
              onChange={() => onChange('PreviousHistory.individualSubjectTo', false)}
            />
            No
          </label>
        </div>
      </div>

      <div>
        In the past five (5) years has the individual been a Director, shareholder or Trustee of a
        business entity at the time it was subject to any of the following:
        <ol className="numbers">
          <li>administration</li>
          <li>receivership</li>
          <li>liquidation (voluntary or involuntary)</li>
          <li>bankruptcy</li>
          <li>debt recovery proceedings</li>
        </ol>
        <FormDisplayErrors
          errors={errorAtKey({ key: 'PreviousHistory.entitySubjectTo', errors })}
        />
        <div className="radioButtonGroup">
          <label>
            <input
              type="radio"
              name="PreviousHistory.entitySubjectTo"
              value={true}
              onChange={() => onChange('PreviousHistory.entitySubjectTo', true)}
            />
            Yes
          </label>
          <label>
            <input
              type="radio"
              name="PreviousHistory.entitySubjectTo"
              value={false}
              onChange={() => onChange('PreviousHistory.entitySubjectTo', false)}
            />
            No
          </label>
        </div>
      </div>

  </fieldset>
)



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/register-mancon-action/form/previous-history.jsx